function getNextImage(gallery) {
  const modalImg = document.querySelector(
    '.wpcf-gallery-modal img.wpcf-gallery-image'
  );
  const currentIndex = parseInt(modalImg.getAttribute('data-index'));

  if (currentIndex == gallery.length - 1) {
    modalImg.src = gallery[0];
    modalImg.setAttribute('data-index', 0);
  } else {
    modalImg.src = gallery[currentIndex + 1];
    modalImg.setAttribute('data-index', currentIndex + 1);
  }
}

function getPrevImage(gallery) {
  const modalImg = document.querySelector(
    '.wpcf-gallery-modal img.wpcf-gallery-image'
  );
  const currentIndex = parseInt(modalImg.getAttribute('data-index'));

  if (currentIndex == 0) {
    modalImg.src = gallery[gallery.length - 1];
    modalImg.setAttribute('data-index', gallery.length - 1);
  } else {
    modalImg.src = gallery[currentIndex - 1];
    modalImg.setAttribute('data-index', currentIndex - 1);
  }
}

export const campaignGallery = () => {
  const galleryImages = [];

  if (document.querySelector('wpcf-gallery')) {
    document
      ?.querySelectorAll('.wpcf-gallery .wpcf-gallery-image')
      .forEach((image) => {
        galleryImages.push(image.src);

        image.addEventListener('click', (e) => {
          const modal = document.querySelector('div.wpcf-gallery-modal');
          const modalImg = document.querySelector(
            '.wpcf-gallery-modal img.wpcf-gallery-image'
          );
          const imgIndex = galleryImages.indexOf(image.src);
          modalImg.src = image.src;
          modalImg.setAttribute('data-index', imgIndex);

          modal.classList.add('modal-open');
        });
      });

    document
      .querySelector('.wpcf-gallery-next')
      .addEventListener('click', (e) => {
        getNextImage(galleryImages);
      });

    document
      .querySelector('.wpcf-gallery-prev')
      .addEventListener('click', (e) => {
        getPrevImage(galleryImages);
      });

    document
      .querySelector('.wpcf-gallery-close, .wpcf-gallery-modal')
      .addEventListener('click', (e) => {
        if (
          e.target.classList.contains('wpcf-gallery-modal') ||
          e.target.classList.contains('wpcf-gallery-close')
        ) {
          document
            .querySelector('div.wpcf-gallery-modal')
            .classList.remove('modal-open');
        }
      });

    document.addEventListener('keydown', (e) => {
      if (document.querySelector('div.wpcf-gallery-modal.modal-open')) {
        if (e.key == 'Escape') {
          document
            .querySelector('div.wpcf-gallery-modal')
            .classList.remove('modal-open');
        }

        if (e.key == 'ArrowLeft') {
          getPrevImage(galleryImages);
        }

        if (e.key == 'ArrowRight') {
          getNextImage(galleryImages);
        }
      }
    });
  }
};
